module.exports = __webpack_public_path__ + "img/nav-header-mobile-eternity.2ce6e7f.jpg";